import { Card } from "@ebsco-ui/ebsco-ui";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { BREAKPOINTS, MY_ACCOUNT_SECTION_ID } from "../../../constants";
import sharedMessages from "../../../shared-messages";
import getIsCoppa from "../../store/coppa";
import AffiliationsSection from "../affiliations-section";
import PageHeader from "../page-header";
import UserInfoImage from "../user-info-image";
import withPersonalization from "../with-personalization";
import MergeAccountsSection from "./merge-accounts-section";
import SkipToSection from "./skip-to-section";
import messages from "./update-messages";
import UpdateUserForm from "./update-user-form";

import "./update.scss";

const Update = ({
  queryString,
  returnUrl,
  isCoppa,
  intl: { formatMessage }
}) => {
  const dataRetentionPageUrl = `/user/data-retention${queryString}`;

  const isMobile = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.SCREEN.PHONE}px)`
  });

  return (
    <main className="update">
      <SkipToSection />
      <PageHeader
        returnUrl={returnUrl}
        isExternalLink={true}
        pageTitleId={MY_ACCOUNT_SECTION_ID}
        returnLinkText={formatMessage(sharedMessages.back)}
        pageTitleText={formatMessage(messages.myAccount)}
      />
      <Card
        isRaised
        isRounded={!isMobile}
        border="all"
        isTransparent={false}
        className="update__card"
      >
        <UserInfoImage />
        <UpdateUserForm />
        <div className="update__divider" />
        <AffiliationsSection />
        <div className="update__divider" />
        <MergeAccountsSection />
        <div className="update__divider" />
        <Link
          className={"data-retention-page-link hyperlink"}
          to={dataRetentionPageUrl}
        >
          {isCoppa ? (
            <FormattedMessage {...messages.myEBSCODataRetentionAndUsage} />
          ) : (
            <FormattedMessage
              {...sharedMessages.personalDataRetentionAndUsage}
            />
          )}
          <FontAwesomeIcon
            icon={faCaretRight}
            className="data-retention-page-link__icon"
          />
        </Link>
      </Card>
    </main>
  );
};

Update.propTypes = {
  returnUrl: PropTypes.string,
  queryString: PropTypes.string
};

const mapStateToProps = state => ({
  queryString: state.router.location.search,
  returnUrl: state.navigation.returnUrl,
  isCoppa: getIsCoppa(state)
});

export { Update };
export default compose(
  withPersonalization,
  injectIntl,
  connect(mapStateToProps)
)(Update);
